export enum RESOURCE_ADJUSTMENT_ITEMS {
  add = 'add another',
  remove = 'remove a',
}
